/**
 * Prop classification constants for nature vs utility categorization
 */

export const NATURE_PROPS = [
  "tree",
  "tree-palm",
  "tree-pine",
  "bush",
  "rock",
  "flower",
] as const;

export type NatureProp = (typeof NATURE_PROPS)[number];
